import { useCallback, useMemo, useState } from 'react';

export const useWizard = ({ steps = [], initialStep = 0 } = {}) => {
    const safeInitialStep = Math.min(Math.max(Number(initialStep) || 0, 0), Math.max(steps.length - 1, 0));
    const [useNameCurrentStepState, setNameCurrentStepState] = useState(safeInitialStep);
    const [useNameMaxVisitedStepState, setNameMaxVisitedStepState] = useState(safeInitialStep);

    const cb__goToCallback = useCallback((index) => {
        const nextIndex = Math.min(Math.max(Number(index) || 0, 0), Math.max(steps.length - 1, 0));
        setNameCurrentStepState(nextIndex);
        setNameMaxVisitedStepState((current) => Math.max(current, nextIndex));
    }, [steps.length]);

    const cb__nextCallback = useCallback(() => {
        cb__goToCallback(useNameCurrentStepState + 1);
    }, [cb__goToCallback, useNameCurrentStepState]);

    const cb__backCallback = useCallback(() => {
        cb__goToCallback(useNameCurrentStepState - 1);
    }, [cb__goToCallback, useNameCurrentStepState]);

    const cb__resetCallback = useCallback(() => {
        setNameCurrentStepState(safeInitialStep);
        setNameMaxVisitedStepState(safeInitialStep);
    }, [safeInitialStep]);

    const memo__wizardStateMemo = useMemo(() => ({
        currentStep: useNameCurrentStepState,
        maxVisitedStep: useNameMaxVisitedStepState,
        step: steps[useNameCurrentStepState] ?? null,
        totalSteps: steps.length,
        isFirstStep: useNameCurrentStepState <= 0,
        isLastStep: useNameCurrentStepState >= Math.max(steps.length - 1, 0),
        progress: steps.length > 0 ? Math.round(((useNameCurrentStepState + 1) / steps.length) * 100) : 0,
    }), [steps, useNameCurrentStepState, useNameMaxVisitedStepState]);

    return {
        ...memo__wizardStateMemo,
        goTo: cb__goToCallback,
        next: cb__nextCallback,
        back: cb__backCallback,
        reset: cb__resetCallback,
    };
};
